import React from 'react';
import { Checkbox, Radio, Stack } from '@mantine/core';
import { IJournalResponseInput, IMultiSelectOptions, QuestionOptions } from '../../../../global/entities/Journal/Journal';

interface MultipleSelectionQuestionProps {
    questionId: number;
    response: IJournalResponseInput | undefined;
    onResponseChange: (questionId: number, updates: Partial<IJournalResponseInput>) => void;
    options: QuestionOptions;
    currentLang: 'en' | 'fr';
    readOnly?: boolean;
}

export const MultipleSelectionQuestion: React.FC<MultipleSelectionQuestionProps> = ({
    questionId,
    response,
    onResponseChange,
    options,
    currentLang,
    readOnly = false
}) => {
    if ((options as IMultiSelectOptions).allowMultiple === true) {
    
        const selectedValues = response?.responseValue ? response.responseValue.split(',') : [];
        
        return (
            <Stack gap="xs">
                {(options as IMultiSelectOptions).options.map((option: any, index: number) => (
                    <Checkbox
                        key={index}
                        label={currentLang === 'fr' ? option.valueFr : option.valueEn}
                        checked={selectedValues.includes(option.valueEn)}
                        onChange={readOnly ? undefined : (e) => {
                            let newValues = [...selectedValues];
                            if (e.target.checked) 
                                newValues.push(option.valueEn);
                             else 
                                newValues = newValues.filter(v => v !== option.valueEn);
                            
                            onResponseChange(questionId, { responseValue: newValues.join(',') });
                        }}
                    />
                ))}
            </Stack>
        );
    } else {
        return (
            <Radio.Group
                value={response?.responseValue || ''}
                onChange={readOnly ? undefined : (value) => onResponseChange(questionId, { responseValue: value })}
            >
                <Stack gap="xs">
                    {(options as IMultiSelectOptions).options.map((option: any, index: number) => (
                        <Radio
                            key={index}
                            value={option.valueEn}
                            label={currentLang === 'fr' ? option.valueFr : option.valueEn}
                        />
                    ))}
                </Stack>
            </Radio.Group>
        );
    }
}; 